module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    staticStyle: {
      "margin-top": "10px",
      "padding": "0px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newdrugs
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增药品")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', {
    staticClass: "distanceLeft",
    attrs: {
      "label": "药品名:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入搜索内容"
    },
    model: {
      value: (_vm.searchData),
      callback: function($$v) {
        _vm.searchData = $$v
      },
      expression: "searchData"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "distanceLeft"
  }, [_c('el-button', {
    staticClass: "el-icon-search",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "distanceLeft",
    attrs: {
      "label": "筛选:"
    }
  }, [
    [_c('el-checkbox-group', {
      on: {
        "change": _vm.handleCheckedCitiesChange
      },
      model: {
        value: (_vm.checkList),
        callback: function($$v) {
          _vm.checkList = $$v
        },
        expression: "checkList"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "药品状态正常"
      }
    }), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "库存预警"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "distanceLeft"
  }, [_c('el-button', {
    staticClass: "el-icon-download",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.download()
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.addData,
      "stripe": "",
      "header-cell-style": _vm.tableHeaderColor
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "药品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "medicineInpart",
      "label": "入药部分"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "manufacturer",
      "label": "产地"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "retailPrice",
      "label": "零售价(￥)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "costPrice",
      "label": "成本价(￥)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "number",
      "label": "剩余数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "recordNumber",
      "label": "预计余量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "inventoryWarning",
      "label": "预警数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }), _vm._v(" "), (_vm.loginIdNumber === '622222222222222222') ? _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleClick(scope.row.id)
            }
          }
        }, [_vm._v("\n                    停用\n                ")]) : (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.startUsing(scope.row.id)
            }
          }
        }, [_vm._v("启用\n                ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.compile(scope.row)
            }
          }
        }, [_vm._v("编辑\n                ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteMedicine(scope.row.id)
            }
          }
        }, [_vm._v("删除\n                ")])]
      }
    }], null, false, 1684796064)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.inventory,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "药品名称:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.inventory.value),
      callback: function($$v) {
        _vm.$set(_vm.inventory, "value", $$v)
      },
      expression: "inventory.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入药部分:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.inventory.medicineInpart),
      callback: function($$v) {
        _vm.$set(_vm.inventory, "medicineInpart", $$v)
      },
      expression: "inventory.medicineInpart"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产地:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.inventory.manufacturer),
      callback: function($$v) {
        _vm.$set(_vm.inventory, "manufacturer", $$v)
      },
      expression: "inventory.manufacturer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "零售价(￥):"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.inventory.retailPrice),
      callback: function($$v) {
        _vm.$set(_vm.inventory, "retailPrice", $$v)
      },
      expression: "inventory.retailPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成本价(￥):"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.inventory.costPrice),
      callback: function($$v) {
        _vm.$set(_vm.inventory, "costPrice", $$v)
      },
      expression: "inventory.costPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "剩余数量:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.inventory.number),
      callback: function($$v) {
        _vm.$set(_vm.inventory, "number", $$v)
      },
      expression: "inventory.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预计余量:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.inventory.recordNumber),
      callback: function($$v) {
        _vm.$set(_vm.inventory, "recordNumber", $$v)
      },
      expression: "inventory.recordNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预警数量:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.inventory.inventoryWarning),
      callback: function($$v) {
        _vm.$set(_vm.inventory, "inventoryWarning", $$v)
      },
      expression: "inventory.inventoryWarning"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "paging"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "current-page": _vm.Current,
      "page-size": this.Size,
      "layout": "total,prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.Current = $event
      },
      "update:current-page": function($event) {
        _vm.Current = $event
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f132363c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pharmacy/nowStock.vue
// module id = 1051
// module chunks = 2